import type { DashboardCardType } from "../../../../types/dashboardLayout";
import { dashboardCardRegistry } from "../layout/dashboardCardRegistry";

export type DashboardRiskMetricsEmbedSection =
  | "keyMetrics"
  | "drawdownChart"
  | "equityPeakPath";

export function getDashboardWidgetTitle(cardType: DashboardCardType): string {
  return dashboardCardRegistry[cardType]?.title ?? "Widget";
}

const LOADING_MESSAGES: Partial<Record<DashboardCardType, string>> = {
  equityPeakPath: "Loading risk metrics and equity curve for your date range…",
  drawdownOverTime: "Loading drawdown series for your date range…",
  keyRiskMetrics: "Loading key risk metrics for your date range…",
  pnlOverTime: "Loading profit and loss over time…",
  portfolioGrowth: "Loading portfolio growth from your account summary…",
  winRateTrend: "Loading win rate trend from your account summary…",
  streakAnalysis: "Loading streak analysis and daily trading activity…",
  performanceBreakdown: "Loading performance breakdown and symbol statistics…",
  longVsShortPerformance: "Loading long vs short performance comparison…",
  tradeDistribution: "Loading trade distribution breakdown…",
  tradeActivityCalendar: "Loading trading activity calendar…",
};

export function getDashboardWidgetLoadingMessage(cardType: DashboardCardType): string {
  return LOADING_MESSAGES[cardType] ?? "Loading widget data for your selected date range…";
}

export function riskMetricsSectionToCardType(
  section: DashboardRiskMetricsEmbedSection
): DashboardCardType | null {
  switch (section) {
    case "keyMetrics":
      return "keyRiskMetrics";
    case "drawdownChart":
      return "drawdownOverTime";
    case "equityPeakPath":
      return "equityPeakPath";
    default:
      return null;
  }
}

export const DASHBOARD_WIDGET_LOADING_DESCRIPTION =
  "Fetching data for your selected account and date range.";
